<template>
	<app>
		<div class="banner"></div>
		
		<module class="tips">
			<p class="ellipsis flex-center-cross"><i class="tf tf-notice"></i>请选择对应的金融机构申报保函内容</p>
		</module>
		
		<module v-if="(!userInfo.id || power('7')) && insuranceList[0] && insuranceList[0].length > 0" class="company-list">
			<ul class="flex-wrap">
				<li v-for="(item, i) in insuranceList[0]" :key="i">
					<div class="logo">
						<img :src="item.image">
					</div>
					<p class="ellipsis-n">{{item.remark}}</p>
					<underwrite class="handle" :company="item.id">立即申报</underwrite>
				</li>
			</ul>
		</module>
		
		<module v-if="(!userInfo.id || power('7')) && insuranceList[2] && insuranceList[2].length > 0" class="module bank-list">
			<div class="module-head flex-baseline">
				<p>银行金融机构</p>
			</div>
			
			<ul class="flex-wrap">
				<li v-for="(item, i) in insuranceList[2]" :key="i">
					<div class="logo">
						<img :src="item.image">
					</div>
					<p class="ellipsis-n">{{item.remark}}</p>
					<div class="flex-end">
						<underwrite class="handle" :company="item.id">立即申报</underwrite>
					</div>
				</li>
			</ul>
		</module>
		
		<module v-if="(!userInfo.id || power('7')) && insuranceList[1] && insuranceList[1].length > 0" class="module petty-list">
			<div class="module-head flex-baseline">
				<p>小额保函</p>
				<span>小的工程项目可以选择小额保函（项目合同金额小于80万）</span>
			</div>
			
			<ul>
				<li v-for="(item, i) in insuranceList[1]" :key="i" class="flex-center">
					<div class="logo">
						<img :src="item.image">
					</div>
					<p class="flex-grow ellipsis-n">{{item.remark}}</p>
					<underwrite class="handle" :company="item.id">立即申报</underwrite>
				</li>
			</ul>
		</module>
		
		<module class="module transact-list">
			<div class="module-head flex-between-center">
				<p>业务办理</p>
			</div>
			
			<ul class="flex-wrap">
				<router-link v-for="(menu, i) in menuList" :key="i" :to="menu.children ? menu.children[0].path : menu.path">
					<li class="item">
						<i class="icon tf" :class="menu.icon"></i>
						<p>{{menu.name}}</p>
						<ins v-if="menu.icon.includes('message') && messageTotal > 0" class="dot">{{messageTotal}}</ins>
					</li>
				</router-link>
			</ul>
		</module>
		
		<module class="module notice-list">
			<div class="module-head flex-between-center">
				<p>政策与通知</p>
				<router-link to="/notice">查看更多 <i class="tf tf-angle-right"></i></router-link>
			</div>
			
			<ul class="flex-wrap">
				<router-link v-for="(item, i) in noticeList" :key="i" :to="{path: '/notice/detail', query: {id: item.id}}" target="_blank"><li>
					<p class="ellipsis-2">{{item.title}}</p>
					<span>{{item.create_date}}</span>
				</li></router-link>
			</ul>
		</module>
	</app>
</template>

<script>
	import underwrite from '@/components/module/underwrite.vue'
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		components: {
			underwrite
		},
		
		data() {
			return {
				currentInsuranceIndex: '',
				insuranceList: [],
				
				noticeList: []
			}
		},
		
		computed: {
			...mapState(['elder', 'userInfo', 'messageTotal']),
			...mapGetters(['menuList', 'power']),
			
			currentInsurance() {
				return this.insuranceType[this.currentInsuranceIndex] || {};
			}
		},
		
		watch: {
			userInfo() {
				this.validUserType();
			},
			
			currentInsuranceIndex() {
				this.updateInsuranceList();
			}
		},
		
		mounted() {
			this.validUserType();
			this.updateInsuranceList();
			this.request({
				url: '/announcement/home_list',
				success: data => {
					this.noticeList = data;
				}
			});
		},
		
		methods: {
			validUserType() {
				if (this.userInfo.user_type === 0 && !this._registerTips) {
					this._registerTips = true;
					this.$confirm({
						text: '账户资料不完整',
						message: '您的账户资料不完整，请先完善资料',
						buttonName: '前往完善资料',
						cancelButtonName: '稍后完善',
						resolve: () => {
							this.navigateTo('/register');
						}
					});
				}
			},
			
			updateInsuranceList() {
				this.request({
					url: '/bxgs/list',
					success: data => {
						this.insuranceList = [
							data.filter(item => item.type == 1),
							data.filter(item => item.type == 2),
							data.filter(item => item.type == 3)
						];
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.banner {
		height: 348px;
		background-image: url('~@/assets/image/banner.jpg');
		background-position: center;
		background-size: cover;
	}
	
	.tips {
		border-bottom: 1px solid #DCE4ED;
		background: #F2F6FB;
		
		p {
			height: 50px;
			font-size: 14px;
			color: #444;
			
			normal({
				max-width: 480px
			})
			
			elder({
				font-size: 20px
			})
			
			.tf {
				vertical-align: -1px;
				margin-right: 8px;
				font-size: 16px;
				color: #F1960D;
			
				elder({
					font-size: 24px
				})
			}
		}
	}
	
	.module {
		padding: 20px 0 50px;
		
		&-head {
			height: 60px;
			margin-bottom: 20px;
			line-height: 60px;
				
			elder({
				height: 100px,
				line-height: 100px
			})
			
			p {
				font-size: 28px;
				font-weight: bold;
				color: #000;
				
				elder({
					font-size: 44px
				})
			}
			
			span {
				margin-left: 12px;
				font-size: 14px;
				color: #999;
				
				elder({
					font-size: 26px
				})
			}
			
			a {
				color: #1492FF;
				
				elder({
					font-size: 24px
				})
			}
		}
	}
	
	.company-list {
		min-height: 325px;
		padding: 30px 0 10px;
		background: #fff;
		
		elder({
			min-height: 429px
		})
		
		ul {
			li {
				box-sizing: border-box;
				width: 282px;
				border: 1px solid #C7D5E6;
				border-radius: 4px;
				padding: 28px 25px 20px;
				margin-left: 24px;
				transition: box-shadow .3s ease;
				
				elder({
					width: 580px
				})
				
				&:nth-child(4n+1) {
					normal({
						margin-left: 0
					})
				}
				
				&:nth-child(n+5) {
					normal({
						margin-top: 20px
					})
				}
				
				&:nth-child(2n+1) {
					elder({
						margin-left: 0
					})
				}
				
				&:nth-child(n+3) {
					elder({
						margin-top: 20px
					})
				}
				
				&:hover {
					box-shadow: 0 0 10px 0 rgba(102,102,102,.2);
				}
				
				.logo {
					height: 55px;
				}
				
				p {
					-webkit-line-clamp: 5;
					height: 130px;
					margin: 30px 0 20px;
					line-height: 26px;
					font-size: 15px;
					color: #444;
					
					elder({
						-webkit-line-clamp: 4,
						height: 144px,
						line-height: 36px,
						font-size: 24px
					})
				}
				
				.handle {
					width: 100%;
					height: 40px;
				}
			}
		}
	}
	
	.bank-list {
		ul {
			li {
				box-sizing: border-box;
				width: 588px;
				border: 1px solid #C7D5E6;
				padding: 28px 25px 20px;
				transition: box-shadow .3s ease;
				
				&:nth-child(n+3) {
					margin-top: 20px
				}
				
				&:nth-child(even) {
					margin-left: 24px
				}
				
				&:hover {
					box-shadow: 0 0 10px 0 rgba(102,102,102,.2);
				}
				
				.logo {
					height: 60px;
				}
				
				p {
					margin: 20px 0;
					-webkit-line-clamp: 3;
					line-height: 26px;
					font-size: 15px;
					color: #444;
					
					elder({
						line-height: 36px,
						font-size: 24px
					})
				}
				
				.handle {
					width: 110px;
					height: 40px;
					
					elder({
						width: 140px
					})
				}
			}
		}
	}
	
	.petty-list {
		ul {
			li {
				box-sizing: border-box;
				border: 1px solid #C7D5E6;
				padding: 36px 20px 36px 30px;
				transition: box-shadow .3s ease;
				
				&:nth-child(n+2) {
					margin-top: 20px
				}
				
				&:hover {
					box-shadow: 0 0 10px 0 rgba(102,102,102,.2);
				}
				
				.logo {
					width: 230px;
				}
				
				p {
					-webkit-line-clamp: 3;
					margin: 0 95px 0 45px;
					line-height: 26px;
					font-size: 15px;
					color: #444;
					
					elder({
						line-height: 36px,
						font-size: 24px
					})
				}
				
				.handle {
					width: 110px;
					height: 40px;
					
					elder({
						width: 140px
					})
				}
			}
		}
	}
	
	.transact-list {
		a {
			margin-left: 24px;
			
			&:nth-child(4n+1) {
				margin-left: 0;
			}
			
			&:nth-child(n+5) {
				margin-top: 24px;
			}
		}
		
		li {
			position: relative;
			width: 282px;
			text-align: center;
			padding: 28px 0 30px;
			color: #1492FF;
			background: #EEF6FD;
			
			&:hover {
				color: #fff;
				background: #1492FF;
			}
			
			.tf {
				font-size: 46px;
			}
			
			p {
				margin-top: 16px;
				font-size: 18px;
				
				elder({
					font-size: 28px
				})
			}
			
			ins {
				position: absolute;
				right: 10px;
				top: 10px;
				box-sizing: border-box;
				min-width:20px;
				height: 20px;
				border-radius: 10px;
				padding: 0 4px;
				line-height: 20px;
				font-size: 13px;
				text-align: center;
				color: #fff;
				background: #E63633;
			}
		}
	}
	
	.notice-list {
		ul {
			a:nth-child(3n+1) li {
				normal({
					margin-left: 0
				})
			}
			
			a:nth-child(1) li {
				elder({
					margin-top: 0
				})
			}
			
			li {
				box-sizing: border-box;
				padding: 40px 26px 32px;
				background: #F6FAFC;
				transition: background .2s ease;
				
				normal({
					width: 380px,
					margin-left: 30px
				})
				
				elder({
					width: 1200px,
					padding: 24px 20px 30px,
					margin-top: 24px
				})
				
				&:hover {
					background: #1492FF;
					box-shadow: 0 5px 7px 0 rgba(20,146,255,.2);
					
					p, span {
						color: #fff;
					}
				}
				
				p {
					margin-bottom: 66px;
					line-height: 28px;
					font-size: 18px;
					color: #000;
					
					normal({
						height: 56px
					})
					
					elder({
						margin-bottom: 20px,
						line-height: 44px,
						font-size: 26px
					})
				}
				
				span {
					font-size: 14px;
					color: #666;
					
					elder({
						font-size: 20px
					})
				}
			}
		}
	}
</style>
